import React from 'react';
import { ModalCloseButton, ModalCloseButtonProps } from '../Modal';

export type SidebarCloseButtonProps = ModalCloseButtonProps;

export const SidebarCloseButton: React.FC<SidebarCloseButtonProps> = (props) => (
  <ModalCloseButton {...props} />
);
